import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";

import { Row, Col } from "antd";
import { SectionTitle } from "../../Titles";
import { ServiceCard } from "../../Cards";
import { IsDesktop, IsMobile, IsPad } from "../../ResponsiveContainers";

import ServicesSlider from "../ServicesSlider";
import { Container, TitleWrap, ServicesWrap, ViewAllProducts } from "./styled";

const ProductsServices = ({ title, data, size, renderAllProductsLink }) => {
  return (
    <Container>
      <TitleWrap>
        <SectionTitle>{title}</SectionTitle>
      </TitleWrap>
      <ServicesWrap>
        <IsDesktop>
          <Row gutter={[20, { xs: 16, sm: 20, md: 20, lg: 20 }]}>
            {data &&
              data.length > 0 &&
              data.map((service, key) => (
                <Col key={key} xs={24} sm={12} md={12} lg={size || 8}>
                  <ServiceCard
                    type={service.type}
                    title={service.title}
                    imgSrc={service.imgSrc}
                    content={service.content}
                    contentTitle={service.contentTitle}
                    btnText={service.btnText}
                    url={service.url}
                  />
                </Col>
              ))}
          </Row>
        </IsDesktop>
        <IsPad>
          <ServicesSlider title={title} data={data} />
        </IsPad>
        <IsMobile>
          <ServicesSlider title={title} data={data} />
        </IsMobile>
      </ServicesWrap>
      { renderAllProductsLink == false
        ? ""
        :
      <Link href={"/view-all-products"}>
        <a>
          <ViewAllProducts>View All Products</ViewAllProducts>
        </a>
      </Link>
      }
    </Container>
  );
};

ProductsServices.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
};

export default ProductsServices;
